import React, { Component } from 'react';
import {
  Icon, Popup,
} from 'semantic-ui-react';
import { AutoSizer, Table, Column } from 'react-virtualized';
import { Scrollbars } from 'react-custom-scrollbars-2';
import withScrollbar from '../Extensions/WithScrollbar';
import api from '../../api';
import SecurityDetailModal from '../Modal/SecurityDetailModal';
import LitigatorDetailModal from '../Modal/LitigatorDetailModal';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';
import RenderProjectTree from '../Extensions/RenderProjectTree';
import TextWithEllipsis from '../Extensions/TextWithEllipsis';
import './ComponentRow.css';

class ComponentRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupStatus: {
        treePopup: false,
        riskPopup: false,
      },
      isOpenMLD: false,
      isOpenMSD: false,
      isOpenMSF: false,
      activeTreeIndex: '',
      activeRiskPopupIndex: '',
      cveData: {},
      selectedCode: '',
      litigatorData: {},
      scannedFileIds: [],
      projectTreeData: [],
      showAllSecurities: false,
    };
    this.handleTreeOpen = this.handleTreeOpen.bind(this);
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleLitigatorDetailModal = this.handleLitigatorDetailModal.bind(this);
    this.handleComponentFileModal = this.handleComponentFileModal.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleComponentFileModal = (ids) => {
    this.setState({
      scannedFileIds: ids,
      isOpenMSF: true,
    });
  };

  handleTreeOpen(string, id, uids) {
    if (string === 'tree') {
      const popupStatus = {
        treePopup: true,
        riskPopup: false,
      };

      this.setState({
        popupStatus,
        activeTreeIndex: id,
        activeRiskPopupIndex: '',
      });
    } else if (string === 'risk') {
      const popupStatus = {
        treePopup: false,
        riskPopup: true,
      };

      this.setState({
        popupStatus,
        activeTreeIndex: '',
        activeRiskPopupIndex: id,
      });
    } else {
      const obj = JSON.parse(`[${uids}]`);
      const objData = { uploaded_file_ids: obj };
      const status = {
        treePopup: true,
        riskPopup: false,
      };

      api
        .getProjectTree(objData)
        .then((response) => {
          const data = response.response;
          this.setState({
            projectTreeData: data,
            popupStatus: status,
            activeTreeIndex: id,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  handleSecurityDetailModal(e, value, securityId) {
    const data = {
      security_name: value,
    };
    if (securityId) {
      data.security_id = securityId;
    }

    api.getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleLitigatorDetailModal(e, string) {
    let value;
    if (string.indexOf('SFC') > -1) {
      value = 'Software Freedom Conservancy';
    } else if (string.indexOf('McHardy') > -1) {
      value = 'Patrick McHardy';
    } else if (string.indexOf('Patent') > -1) {
      value = 'Patents';
    }

    if (!value) {
      value = string;
    }

    const data = {
      litigator_name: value,
    };
    api.getComponentLitigatorDetail(data)
      .then((response) => {
        this.setState({
          litigatorData: response.response,
          isOpenMLD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  filterSecurities = (list) => {
    const { showAllSecurities } = this.state;
    if (showAllSecurities) {
      return list;
    }
    return list.filter((item) => { return item.is_vulnerable; });
  };

  setShowAllSecurities = (value) => {
    this.setState({
      showAllSecurities: value,
    });
  };

  closePopup() {
    const { isOpenMLD, isOpenMSD } = this.state;

    if (isOpenMLD || isOpenMSD) {
      return;
    }

    const popupStatus = {
      treePopup: false,
      riskPopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: '',
      activeRiskPopupIndex: '',
      showAllSecurities: false
    });
  }

  closeModal() {
    this.setState({
      litigatorData: {},
      cveData: {},
      scannedFileIds: [],
      selectedCode: '',
      isOpenMLD: false,
      isOpenMSD: false,
      isOpenMSF: false,
    });
  }

  render() {
    const {
      parentRowData,
      uid,
      t,
      location,
      params,
      state
    } = this.props;

    const {
      popupStatus,
      activeTreeIndex,
      activeRiskPopupIndex,
      litigatorData,
      isOpenMLD,
      isOpenMSD,
      isOpenMSF,
      cveData,
      selectedCode,
      scannedFileIds,
      projectTreeData,
      showAllSecurities,
    } = this.state;

    const pathname = location.pathname ? location.pathname : location;

    let flattenedData;

    if (pathname.indexOf(params.idReport) > -1) {
      flattenedData = Object.keys(parentRowData.components).reduce((acc, version) => {
        const items = parentRowData.components[version].map((item) => { return { ...item, version }; });
        return acc.concat(items);
      }, []);
    } else {
      flattenedData = parentRowData.components;
    }

    const cellRendererVersion = ({ cellData }) => {
      return (
        <div
          className="tac border-bottom"
        >
          <TextWithEllipsis className="" as="span" text={cellData} />
        </div>
      );
    };

    const cellRendererName = ({ rowIndex, cellData }) => {
      const scannedFileId = flattenedData[rowIndex].scanned_file_ids;
      return (
        <div
          className="tac border-bottom has_link"
        >
          <TextWithEllipsis
            className=""
            as="span"
            text={cellData}
            onClick={() => { return this.handleComponentFileModal(scannedFileId); }}
          />
        </div>
      );
    };

    const cellRendererSummary = ({ rowData, rowIndex }) => {
      const filteredCritical = this.filterSecurities(rowData.securities.critical);
      const filteredHigh = this.filterSecurities(rowData.securities.high);
      const filteredMedium = this.filterSecurities(rowData.securities.medium);
      const filteredLow = this.filterSecurities(rowData.securities.low);

      const totalSecurityCount = filteredCritical.length
      + filteredHigh.length
      + filteredMedium.length
      + filteredLow.length;

      return (
        <div className="sum_td border-bottom">
          <Popup
            trigger={(
              <div
                className="hover_area"
              >
                <table className="sub_table">
                  <colgroup>
                    <col
                      style={{
                        width: '41.4%',
                      }}
                    />
                    <col
                      style={{
                        width: '34.3%',
                      }}
                    />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td className="tac">
                        <div className="belt_chart">
                          <div className="red">
                            {rowData.security_count.critical}
                          </div>
                          <div className="orange">
                            {rowData.security_count.high}
                          </div>
                          <div className="cheese">
                            {rowData.security_count.medium}
                          </div>
                          <div className="yellow">
                            {rowData.security_count.low}
                          </div>
                        </div>
                        {
                          rowData.has_exploit ? (<Icon name="bug" />) : null
                        }
                      </td>
                      <td className="tac">
                        <div className="belt_chart round">
                          <div className="red">
                            {rowData.license_count.protective}
                          </div>
                          <div className="cheese">
                            {rowData.license_count.permissive}
                          </div>
                          <div className="yellow">
                            {rowData.license_count.others}
                          </div>
                        </div>
                      </td>
                      <TextWithEllipsis className="tac" as="td" text={rowData.title_license} />
                      <TextWithEllipsis className="tac" as="td" text={rowData.litigator_string} />
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            inverted
            on="click"
            position="bottom left"
            open={
              popupStatus.treePopup && activeTreeIndex === `${rowData.component_version}_${rowIndex}`
            }
            onOpen={() => {
              return this.handleTreeOpen('tree', `${rowData.component_version}_${rowIndex}`);
            }}
            onClose={this.closePopup}
            hideOnScroll={!isOpenMSD}
          >
            <div className="expand_sub_popup">
              <table
                className="expand_sub_popup_table"
              >
                <colgroup>
                  <col width="230px" />
                  <col width="230px" />
                  <col width="150px" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.security_risk')}
                          (
                          {totalSecurityCount}
                          )
                          <button
                            type="button"
                            onClick={() => { return this.setShowAllSecurities(!showAllSecurities); }}
                            style={{
                              flexShrink: 0,
                              marginLeft: '10px',
                              backgroundColor: showAllSecurities
                                ? '#444'
                                : '#1b1c1d',
                              color: '#fff',
                              border: '1px solid #555',
                              borderRadius: '4px',
                              padding: '2px 8px',
                              cursor: 'pointer',
                              fontSize: '11px',
                              lineHeight: '1.2',
                            }}
                          >
                            {showAllSecurities
                              ? t('list.title.vulnerable_only')
                              : t('list.title.show_all')}
                          </button>
                        </p>
                      </div>
                    </th>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.license')}
                          (
                          {rowData.licenses.protective.length
                      + rowData.licenses.permissive.length
                      + rowData.licenses.others.length}
                          )
                        </p>
                      </div>
                    </th>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.litigator')}
                          (
                          {rowData.litigators.length}
                          )
                        </p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block block_4">
                              {t('list.title.risk_level')}
                            </div>
                            <div className="block block_6">
                              {t('list.title.risk_code')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {filteredCritical
                              .length > 0 ? (
                                <div className="block_wrap">
                                  {filteredCritical.map(
                                    (value) => {
                                      return (
                                        <div key={value.code.toString()}>
                                          <div
                                            className="block block_4"
                                            style={{
                                              textDecoration: value.is_vulnerable
                                                ? 'none'
                                                : 'line-through',
                                              opacity: value.is_vulnerable ? 1 : 0.6,
                                            }}
                                          >
                                            {t('list.title.critical')}
                                          </div>
                                          <div
                                            className="block block_6 bullet bullet_red has_link"
                                            style={{
                                              textDecoration: value.is_vulnerable
                                                ? 'none'
                                                : 'line-through',
                                              opacity: value.is_vulnerable ? 1 : 0.6,
                                            }}
                                            onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                            onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          >
                                            <span>{value.code}</span>
                                            {value.is_exploit ? (<Icon name="bug" />) : null}
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              ) : null}
                            {filteredHigh.length > 0 ? (
                              <div className="block_wrap">
                                {filteredHigh.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.code.toString()}
                                      >
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.high')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_orange has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {filteredMedium.length > 0 ? (
                              <div className="block_wrap">
                                {filteredMedium.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.code.toString()}
                                      >
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.medium')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_cheese has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {filteredLow.length > 0 ? (
                              <div className="block_wrap">
                                {filteredLow.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.code.toString()}
                                      >
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.low')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_yellow has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block block_4">
                              {t('list.title.license_family')}
                            </div>
                            <div className="block block_6">
                              {t('list.title.license_name')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.licenses.protective
                              .length > 0 ? (
                                <div className="block_wrap">
                                  {rowData.licenses.protective.map(
                                    (value) => {
                                      return (
                                        <div
                                          key={value.toString()}
                                        >
                                          <div className="block block_4">
                                            {t('list.title.protective')}
                                          </div>
                                          <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_red" text={value} />
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              ) : null}
                            {rowData.licenses.permissive
                              .length > 0 ? (
                                <div className="block_wrap">
                                  {rowData.licenses.permissive.map(
                                    (value) => {
                                      return (
                                        <div
                                          key={value.toString()}
                                        >
                                          <div className="block block_4">
                                            {t('list.title.permissive')}
                                          </div>
                                          <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_orange" text={value} />
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              ) : null}
                            {rowData.licenses.others.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.others.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.others')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_yellow" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block">
                              {t('list.title.litigator_code')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.litigators.length > 0 ? (
                              <div>
                                {rowData.litigators.map(
                                  (value) => {
                                    return (
                                      <div
                                        className="block_wrap"
                                        key={value.toString()}
                                      >
                                        <div
                                          style={{ float: 'none' }}
                                          className="block has_link"
                                          onClick={(e) => { return this.handleLitigatorDetailModal(e, value); }}
                                          onKeyUp={(e) => { return this.handleLitigatorDetailModal(e, value); }}
                                        >
                                          <span>{value}</span>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Popup>
        </div>
      );
    };

    const cellRendererRisk = ({ rowData }) => {
      return (
        <div className="sum_td border-bottom">
          <Popup
            trigger={(
              <div
                className="hover_area"
              >
                <table className="sub_table">
                  <colgroup>
                    <col style={{ width: '41.4%' }} />
                    <col style={{ width: '36.3%' }} />
                    <col style={{ width: '10%' }} />
                    <col style={{ width: '' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td className="tac">
                        <div className="belt_chart">
                          <div className="red">
                            {rowData.security_count.critical}
                          </div>
                          <div className="orange">
                            {rowData.security_count.high}
                          </div>
                          <div className="cheese">
                            {rowData.security_count.medium}
                          </div>
                          <div className="yellow">
                            {rowData.security_count.low}
                          </div>
                        </div>
                        {
                          rowData.has_exploit ? (<Icon name="bug" />) : null
                        }
                      </td>
                      <td className="tac">
                        <div className="belt_chart round">
                          <div className="red">
                            {rowData.license_count.protective}
                          </div>
                          <div className="cheese">
                            {rowData.license_count.permissive}
                          </div>
                          <div className="yellow">
                            {rowData.license_count.others}
                          </div>
                        </div>
                      </td>
                      <TextWithEllipsis className="tac" as="td" text={rowData.title_license} />
                      <TextWithEllipsis className="tac" as="td" text={rowData.litigator_string} />
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            inverted
            on="click"
            position="bottom left"
            open={
              popupStatus.riskPopup && activeRiskPopupIndex === rowData.component_version
            }
            onOpen={() => {
              return this.handleTreeOpen('risk', rowData.component_version);
            }}
            onClose={this.closePopup}
            hideOnScroll={!isOpenMSD}
          >
            <div
              className="expand_sub_popup"
            >
              <table className="expand_sub_popup_table">
                <colgroup>
                  <col width="230px" />
                  <col width="230px" />
                  <col width="150px" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.security_risk')}
                          (
                          {rowData.securities.critical.length
                                  + rowData.securities.high.length
                                  + rowData.securities.medium.length
                                  + rowData.securities.low.length}
                          )
                        </p>
                      </div>
                    </th>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.license')}
                          (
                          {rowData.licenses.protective.length
                                  + rowData.licenses.permissive.length
                                  + rowData.licenses.others.length}
                          )
                        </p>
                      </div>
                    </th>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.litigator')}
                          (
                          {rowData.litigators.length}
                          )
                        </p>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block block_4">
                              {t('list.title.risk_level')}
                            </div>
                            <div className="block block_6">
                              {t('list.title.risk_code')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.securities.critical.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.securities.critical.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div className="block block_4">
                                          {t('list.title.critical')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_red has_link"
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.securities.high.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.securities.high.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div className="block block_4">
                                          {t('list.title.high')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_orange has_link"
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.securities.medium.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.securities.medium.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div className="block block_4">
                                          {t('list.title.medium')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_cheese has_link"
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.securities.low.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.securities.low.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div className="block block_4">
                                          {t('list.title.low')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_yellow has_link"
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block block_4">
                              {t('list.title.license_family')}
                            </div>
                            <div className="block block_6">
                              {t('list.title.license_name')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.licenses.protective.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.protective.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.protective')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_red" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.licenses.permissive.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.permissive.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.permissive')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_orange" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.licenses.others.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.others.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.others')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_yellow" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block">
                              {t('list.title.litigator_code')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.litigators.length > 0 ? (
                              <div>
                                {rowData.litigators.map((value) => {
                                  return (
                                    <div
                                      className="block_wrap"
                                      key={value.toString()}
                                    >
                                      <div
                                        style={{ float: 'none' }}
                                        className="block has_link"
                                        onClick={(e) => { return this.handleLitigatorDetailModal(e, value); }}
                                        onKeyUp={(e) => { return this.handleLitigatorDetailModal(e, value); }}
                                      >
                                        <span>{value}</span>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Popup>
        </div>
      );
    };

    const cellRenderTree = ({ rowData }) => {
      return (
        <div className="sum_td border-bottom">
          <Popup
            trigger={(
              <div
                className="hover_area"
              >
                <table className="sub_table">
                  <colgroup>
                    <col style={{ width: '33%' }} />
                    <col style={{ width: '33%' }} />
                    <col style={{ width: '33%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td className="tac">{rowData.project_count}</td>
                      <td className="tac">
                        {rowData.project_version_count}
                      </td>
                      <td className="tac">
                        {rowData.uploaded_file_count}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            on="click"
            position="bottom left"
            open={
              popupStatus.treePopup && activeTreeIndex === rowData.component_version
            }
            onOpen={() => {
              return this.handleTreeOpen('tree_api', rowData.component_version, rowData.uploaded_file_ids);
            }}
            onClose={this.closePopup}
            hideOnScroll
            wide="very"
          >
            <RenderProjectTree
              treeData={projectTreeData}
              translate={t}
              tableType
              state={state}
            />
          </Popup>
        </div>
      );
    };

    const cellRendererLastDetected = ({ cellData }) => {
      return (
        <div
          className="tac border-bottom"
          id="smallText"
        >
          <TextWithEllipsis className="" as="span" text={cellData} />
        </div>
      );
    };

    if (pathname.indexOf(params.idReport) > -1) {
      return (
        <div style={{ height: '100%', width: '100%' }}>
          <AutoSizer>
            {({ width, height }) => {
              return (
                <Table
                  width={width}
                  height={height}
                  headerHeight={0}
                  rowHeight={60}
                  rowCount={flattenedData.length}
                  rowGetter={({ index }) => { return flattenedData[index]; }}
                >
                  <Column
                    dataKey="component_version"
                    width={width * 0.172}
                    cellRenderer={cellRendererVersion}
                  />
                  <Column
                    dataKey="scanned_file_name"
                    width={width * 0.172}
                    cellRenderer={cellRendererName}
                  />
                  <Column
                    width={width * 0.656}
                    dataKey="summary"
                    cellRenderer={({ rowData, rowIndex }) => { return cellRendererSummary({ rowData, rowIndex }); }}
                  />
                </Table>
              );
            }}
          </AutoSizer>
          <SecurityDetailModal
            isOpenMSD={isOpenMSD}
            closeModal={this.closeModal}
            cveData={cveData}
            selectedCode={selectedCode}
            translate={t}
          />
          <LitigatorDetailModal
            isOpenMLD={isOpenMLD}
            closeModal={this.closeModal}
            litigatorData={litigatorData}
            translate={t}
          />
          <ScannedFilesInfoModal
            isOpenMSF={isOpenMSF}
            closeModal={this.closeModal}
            ufid={uid}
            scannedFileIds={scannedFileIds}
            translate={t}
          />
        </div>
      );
    }
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <AutoSizer>
          {({ width, height }) => {
            return (
              <Table
                width={width}
                height={height}
                headerHeight={0}
                rowHeight={60}
                rowCount={flattenedData.length}
                rowGetter={({ index }) => { return flattenedData[index]; }}
              >
                <Column
                  dataKey="component_version"
                  width={width * 0.101}
                  cellRenderer={cellRendererVersion}
                />
                <Column
                  dataKey="summary"
                  width={width * 0.583}
                  cellRenderer={({ rowData }) => { return cellRendererRisk({ rowData }); }}
                />
                <Column
                  width={width * 0.215}
                  dataKey="tree_view"
                  cellRenderer={({ rowData }) => { return cellRenderTree({ rowData }); }}
                />
                <Column
                  dataKey="last_detected"
                  width={width * 0.104}
                  cellRenderer={cellRendererLastDetected}
                />
              </Table>
            );
          }}
        </AutoSizer>
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.closeModal}
          cveData={cveData}
          selectedCode={selectedCode}
          translate={t}
        />
        <LitigatorDetailModal
          isOpenMLD={isOpenMLD}
          closeModal={this.closeModal}
          litigatorData={litigatorData}
          translate={t}
        />
        <ScannedFilesInfoModal
          isOpenMSF={isOpenMSF}
          closeModal={this.closeModal}
          ufid={uid}
          scannedFileIds={scannedFileIds}
          translate={t}
        />
      </div>
    );

  }
}

export default withScrollbar(ComponentRow);
